import { SwiperProps } from 'swiper/react'; // eslint-disable-line import/no-unresolved
import { Container } from 'components/gruenland/atoms/container/Container';
import Slider from 'components/gruenland/atoms/slider/Slider';
import ProductTile from 'components/gruenland/molecules/product-tile/ProductTile';
import { Product } from 'types/entity/product';
import { LineItem, Wishlist } from 'types/entity/wishlist';

export type ProductSliderProps = Omit<Partial<SwiperProps>, 'spaceBetween' | 'title'> & {
  products: Product[];
  wishlist?: Wishlist;
  slidesPerView?: number;
  disableProductWishlistButton?: boolean;
  onProductClick?: (product: Product) => void;
  variant?: 'normal' | 'cart';
  addToWishlist?: (lineItem: LineItem, count: number) => Promise<void>;
  removeLineItem?: (item: LineItem) => Promise<void>;
  spaceBetween?: number;
};

const ProductSlider: React.FC<ProductSliderProps> = ({
  products,
  wishlist,
  disableProductWishlistButton = false,
  addToWishlist,
  removeLineItem,
  onProductClick,
  spaceBetween = 8,
  ...props
}) => {
  return (
    <Container>
      <Slider dots arrows allowTouchMove spaceBetween={spaceBetween} {...props}>
        {products.map((product) => (
          <ProductTile
            key={product.productId}
            wishlist={wishlist}
            disableWishlistButton={disableProductWishlistButton}
            product={product}
            onClick={() => {
              onProductClick?.(product);
            }}
            addToWishlist={addToWishlist}
            removeLineItem={removeLineItem}
            disableVariants={true}
          />
        ))}
      </Slider>
    </Container>
  );
};

export default ProductSlider;
